jQuery(document).ready(function ($) {


	// SHARE ON SOCIALS  ------------------------------------------

	$('.facebookShare').on('click', function(e) {
		var url 	 = $(this).attr('data-url');
		var w_width  = $(window).width();
		var w_height = $(window).height();
		var popup_width = 600;
        window.open(
        	url, 
        	'Share', 
        	"top="+(w_height-400)/2+",left="+(w_width-popup_width)/2+",width="+popup_width+", height=400"
        );
	})
	$('.linkedinShare').on('click', function(e) {
		var url 	 = $(this).attr('data-url');
		var w_width  = $(window).width();
		var w_height = $(window).height();
		var popup_width = 600;
        window.open(
        	url, 
        	'Share', 
        	"top="+(w_height-600)/2+",left="+(w_width-popup_width)/2+",width="+popup_width+", height=650"
        );
	})
	$('.urlShare').on('click', function(e) {
		const url 	   = $(this).attr('data-url');
		const feedback = $(this).find('.share_url_feedback');
		navigator.clipboard.writeText(url).then(() => {
			feedback.removeClass('hidden');
			setTimeout(() => {
				feedback.addClass('hidden');
			}, 3000);
		}).catch(err => {
			log('Failed to copy: ', err);
		});
	})

	

}); // end ready